import { Icon } from "@iconify/react";
import { useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import LogoutHandler from "../../utils/logout";

function BatMenuClient(props) {

  const { navigation } = props;
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showHistoryDropdown, setShowHistoryDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const dropdownRef = useRef(null);
  const historyDropdownRef = useRef(null);
  
  const userState = useSelector(state => state.user);
  const officeState = useSelector(state => state.office);

  // Fonction pour obtenir les informations du badge selon le rank
  const getBadgeInfo = (rank) => {
    switch (rank) {
      case 'VIP':
        return {
          show: true,
          text: 'VIP',
          colorClass: 'badge-vip' // violet
        };
      case 'ULTRA':
        return {
          show: true,
          text: 'ULTRA',
          colorClass: 'badge-ultra' // jaune
        };
      case 'DIAMOND':
        return {
          show: true,
          text: 'DIAMANT',
          colorClass: 'badge-diamond' // vert
        };
      case 'DEFAULT':
      default:
        return {
          show: false,
          text: '',
          icon: '',
          colorClass: ''
        };
    }
  };

  const badgeInfo = getBadgeInfo(userState?.data?.rank);

  // Fermer les dropdowns quand on clique en dehors
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserDropdown(false);
      }
      if (historyDropdownRef.current && !historyDropdownRef.current.contains(event.target)) {
        setShowHistoryDropdown(false);
      }
      // Fermer le menu mobile si on clique en dehors
      if (!event.target.closest('.mobile-menu-toggle') && !event.target.closest('.navbar-menu')) {
        setShowMobileMenu(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fonction pour fermer le menu mobile
  const closeMobileMenu = () => {
    setShowMobileMenu(false);
  };

  return (
    <nav className={`modern-navbar ${props.showBatMenu ? "show" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-brand">
          <div className="brand-logo">
            <img 
              src={officeState.data["logoImage"] || "/assets/logo.svg"} 
              alt="Logo" 
              className="logo-image"
            />
          </div>
        </div>

        {/* Bouton hamburger pour mobile */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          aria-label="Toggle menu"
        >
          <Icon 
            icon={showMobileMenu ? "ic:baseline-close" : "ic:baseline-menu"} 
            className="hamburger-icon"
          />
        </button>

        {/* Navigation principale */}
        <div className={`navbar-menu ${showMobileMenu ? 'mobile-open' : ''}`}>
          <ul className="navbar-nav">
            <li className="nav-item" onClick={() => { navigation("/" + props.officeName + "/client/expertList"); closeMobileMenu(); }}>
              <Icon icon="simple-icons:googlecolab" className="nav-icon" />
              <span className="nav-text">Je consulte</span>
            </li>
            <li className="nav-item dropdown-item" ref={historyDropdownRef}>
              <div 
                className="nav-link"
                onClick={() => setShowHistoryDropdown(!showHistoryDropdown)}
              >
                <Icon icon="ic:baseline-history" className="nav-icon" />
                <span className="nav-text">Historique</span>
                <Icon 
                  icon="ic:baseline-keyboard-arrow-down" 
                  className={`dropdown-arrow ${showHistoryDropdown ? 'open' : ''}`}
                />
              </div>
              
              {/* Dropdown menu Historique */}
              {showHistoryDropdown && (
                <div className="nav-dropdown">
                  <div className="dropdown-content">
                    <button 
                      className="dropdown-item"
                      onClick={() => {
                        navigation("/" + props.officeName + "/client/myconsultations");
                        setShowHistoryDropdown(false);
                        closeMobileMenu();
                      }}
                    >
                      <span>Consultations</span>
                    </button>
                    <button 
                      className="dropdown-item"
                      onClick={() => {
                        navigation("/" + props.officeName + "/client/mypurchase");
                        setShowHistoryDropdown(false);
                        closeMobileMenu();
                      }}
                    >
                      <span>Achats</span>
                    </button>
                  </div>
                </div>
              )}
            </li>
            <li
              className="nav-item"
              onClick={() => {
                navigation("/" + props.officeName + "/client/payement");
                closeMobileMenu();
              }}
            >
              <Icon icon="solar:cart-5-line-duotone" className="nav-icon" />
              <span className="nav-text">Recharger</span>
            </li>
            <li
              className="nav-item"
              onClick={() => {
                navigation("/" + props.officeName + "/client/avantages");
                closeMobileMenu();
              }}
            >
              <Icon icon="ic:baseline-loyalty" className="nav-icon" />
              <span className="nav-text">Avantages</span>
            </li>
            <li
              className="nav-item"
              onClick={() => { navigation("/" + props.officeName + "/client/mails"); closeMobileMenu(); }}
            >
              <Icon icon="material-symbols:mail-outline-rounded" className="nav-icon" />
              <span className="nav-text">Mes Mails</span>
            </li>
            <li
              className="nav-item"
              onClick={() => {
                navigation("/" + props.officeName + "/client/mymeeting");
                closeMobileMenu();
              }}
            >
              <Icon icon="ic:baseline-message" className="nav-icon" />
              <span className="nav-text">Mes RDV</span>
            </li>
          </ul>
        </div>

        {/* Section utilisateur */}
        <div className="navbar-user" ref={dropdownRef}>
          <div className="user-info" onClick={() => setShowUserDropdown(!showUserDropdown)}>
            <div className="user-avatar">
              <Icon icon="mdi:account" className="avatar-icon" />
              {badgeInfo.show && (
                <div className={`grade-badge ${badgeInfo.colorClass}`}>
                  <Icon icon={badgeInfo.icon} className="grade-icon" />
                  <span className="grade-text">{badgeInfo.text}</span>
                </div>
              )}
            </div>
            <div className="user-details">
              <div className="user-badge">
                <span className="badge-label">Solde</span>
                <span className="badge-value">{userState?.data?.time || "0"}</span>
              </div>
              <div className="points-badge">
                <Icon icon="ic:baseline-loyalty" className="points-icon" />
                <span className="points-text">{userState?.data?.loyaltyPoints || "0 pts"}</span>
              </div>
            </div>
            <Icon 
              icon="ic:baseline-keyboard-arrow-down" 
              className={`dropdown-arrow ${showUserDropdown ? 'open' : ''}`}
            />
          </div>
          
          {/* Dropdown menu */}
          {showUserDropdown && (
            <div className="user-dropdown">
              <div className="dropdown-content">
                <button 
                  className="dropdown-item"
                  onClick={() => {
                    navigation("/" + props.officeName + "/client/profile");
                    setShowUserDropdown(false);
                  }}
                >
                  <Icon icon="mdi:account" className="dropdown-icon" />
                  <span>Mon profil</span>
                </button>
                <div className="dropdown-divider"></div>
                <div className="dropdown-item logout-item" onClick={() => setShowUserDropdown(false)}>
                  <LogoutHandler officeName={props.officeName} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default BatMenuClient;
